import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Warning: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M13 15V9h-2v6h2zM13 18v-2h-2v2h2z" />
    <path
      fillRule="evenodd"
      d="M23.723 21.5L12 .984.277 21.5h23.446zm-3.446-2H3.723L12 5.016 20.277 19.5z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
